import { render, staticRenderFns } from "./InputsPedidosExternos.vue?vue&type=template&id=b3d213ca&scoped=true&"
import script from "./InputsPedidosExternos.vue?vue&type=script&lang=js&"
export * from "./InputsPedidosExternos.vue?vue&type=script&lang=js&"
import style0 from "./InputsPedidosExternos.vue?vue&type=style&index=0&id=b3d213ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d213ca",
  null
  
)

export default component.exports